export const eulerSwapAddresses = {
  eulerSwapV1Factory: "0xD14c95dc228E8851F63d9b83A0001F4D021B5DFf",
  eulerSwapV1Implementation: "0x0e05d236cb6c350935751A73e834A13111998e3c",
  eulerSwapV1Periphery: "0x46F951278f52f4798542C51BfB8Df1c165199150",
} as const
